import { cloneDeep } from "lodash";
import Constants from 'constants/actions';

const defaultState = {
    bookingData: [],
    bookingCloned: [],
    fetching: false
};

const myBooking = (state = defaultState, action) => {
    const { type = '', payload = [] } = action;
    switch (type) {
        case Constants.MY_BOOKINGS.MY_BOOKING: {
            const cloneData = cloneDeep(payload);
            return {
                ...state,
                bookingData: payload,
                bookingCloned: cloneData,
                fetching: true
            }
        }
        case Constants.MY_BOOKINGS.ALL_BOOKING: {
            return {
                ...state,
                bookingData: payload,
            }
        }
        case Constants.MY_BOOKINGS.UPCOMING_BOOKING: {
            return {
                ...state,
                bookingData: payload
            }
        }
        case Constants.MY_BOOKINGS.CANCELLED_BOOKING: {
            return {
                ...state,
                bookingData: payload
            }
        }
        case Constants.MY_BOOKINGS.COMPLETED_BOOKING: {
            return {
                ...state,
                bookingData: payload
            }
        }
    }
    return state;
}

export default myBooking
